import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import './layer-item-card.css';
import { ModelNameHandler } from "../../model-name-handler/model-name-handler";
import { LayerItemWithChangeableSubmodelName, NewLayerItemWithChangeableSubmodelName } from "../../../../../types/api/layer-item/layer-item";
import { LayerItemSubmodelNameHandler, LayerItemSubmodelNameHandlerRef } from "./layer-item-submodel-name-handler/layer-item-submodel-name-handler";
import { useRef } from "react";
import * as THREE from 'three';
import { getImageUrl } from "../../../../../../utils/image-helper/get-image-url";

type LayerItemCardProps = {
    project: Project;
    layerItem: LayerItemWithChangeableSubmodelName | NewLayerItemWithChangeableSubmodelName;
    selectedModelUUID: string | null;
    isOpen: boolean;
    onOpenAccordion: () => void;
    onCloseAccordion: () => void;
    onLayerItemDelete?: () => void;
    onLayerItemModelNameChange?: (name: string) => void;
    onModelSelectClick?: () => void;
    onOtherModelChooseClick?: () => void;
    onSubmodelSelectClick?: () => void;
    onOtherSubmodelChooseClick?: () => void;
    onSubmodelNameClick?: () => void;
    onSubmodelNameCancelClick?: () => void;
    onSubmodelNameSaveClick?: (name: string) => void;
};

export const LayerItemCard = ({
        layerItem,
        isOpen,
        onOpenAccordion,
        onCloseAccordion,
        project,
        selectedModelUUID,
        onLayerItemDelete,
        onLayerItemModelNameChange,
        onModelSelectClick,
        onOtherModelChooseClick,
        onSubmodelSelectClick,
        onOtherSubmodelChooseClick,
        onSubmodelNameClick,
        onSubmodelNameCancelClick,
        onSubmodelNameSaveClick
    }: LayerItemCardProps) => {
    
    const submodelNameHandlerRef = useRef<LayerItemSubmodelNameHandlerRef>();

    return (
        <>
            <Accordion
                open={isOpen ? '1' : ''}
                toggle={
                    () => {
                        if (isOpen) onCloseAccordion();
                        else onOpenAccordion();
                    }
                }
                className="layer-item-card-accordion"
            >
                <AccordionItem>
                    <AccordionHeader targetId={'1'} className="layer-item-card-accordion-header">
                        <ModelNameHandler
                            editIconColor='black'
                            defaultValue={layerItem.name ?? ''}
                            onSave={
                                (name) => {
                                    if (onLayerItemModelNameChange) onLayerItemModelNameChange(name);
                                }
                            }
                        />
                        <img
                            src={getImageUrl('delete-icon.png')}
                            alt="del"
                            onClick={
                                (e) => {
                                    e.stopPropagation();
                                    if (onLayerItemDelete) onLayerItemDelete();
                                }
                            }
                            title="Törlés"
                        />
                    </AccordionHeader>
                    <AccordionBody accordionId={'1'}>
                        <div className='mb-1'>
                            <span
                                className={`text-decoration-underline cursor-pointer ${ layerItem.modelUUID && layerItem.modelUUID === selectedModelUUID && 'fw-bold' }`}
                                onClick={
                                    (e) => {
                                        e.stopPropagation();
                                        if (onModelSelectClick) onModelSelectClick();
                                    }
                                }
                            >
                                *Elem kiválasztás
                            </span>
                            <br />
                            {
                                layerItem.modelUUID ? (
                                    <>
                                        <div style={{ paddingTop: '2px', paddingBottom: '2px' }}>
                                            <span
                                                className="cursor-pointer"
                                                onClick={
                                                    (e) => {
                                                        e.stopPropagation();
                                                        if (onOtherModelChooseClick) onOtherModelChooseClick();
                                                    }
                                                }
                                            >Másik modellt választok</span>
                                        </div>
                                        <div className="d-flex gap-2 align-items-center">
                                            <img src={getImageUrl('check-icon.png')} alt='check-icon' style={{ width: '20px' }} />
                                            <div>
                                                Pozíció X:{layerItem.modelXPosition} Y:{layerItem.modelYPosition} Z:{layerItem.modelZPosition}
                                                <br />
                                                Rotáció X:{THREE.MathUtils.radToDeg(layerItem.modelXRotation)} Y:{THREE.MathUtils.radToDeg(layerItem.modelYRotation)} Z:{THREE.MathUtils.radToDeg(layerItem.modelZRotation)}
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <span className='red-question-mark fw-bold'>?</span>
                                )
                            }
                        </div>
                        <div className='mb-1'>
                            <span
                                className={`text-decoration-underline cursor-pointer ${ layerItem.submodelUUID && layerItem.submodelUUID === selectedModelUUID && 'fw-bold' }`}
                                onClick={
                                    (e) => {
                                        e.stopPropagation();
                                        if (onSubmodelSelectClick) onSubmodelSelectClick();
                                    }
                                }
                            >
                                Subelem kiválasztás
                            </span>
                            <br />
                            {
                                layerItem.submodelUUID ? (
                                    <>
                                        <div style={{ paddingTop: '2px', paddingBottom: '2px' }}>
                                            <span
                                                className="cursor-pointer"
                                                onClick={
                                                    (e) => {
                                                        e.stopPropagation();
                                                        if (onOtherSubmodelChooseClick) onOtherSubmodelChooseClick();
                                                    }
                                                }
                                            >Másik modellt választok</span>
                                        </div>
                                        <div className="d-flex gap-2 align-items-center">
                                            <img src={getImageUrl('check-icon.png')} alt='check-icon' style={{ width: '20px' }} />
                                            <div>
                                                Pozíció X:{layerItem.submodelXPosition} Y:{layerItem.submodelYPosition} Z:{layerItem.submodelZPosition}
                                                <br />
                                                Rotáció X:{THREE.MathUtils.radToDeg(layerItem.submodelXRotation)} Y:{THREE.MathUtils.radToDeg(layerItem.submodelYRotation)} Z:{THREE.MathUtils.radToDeg(layerItem.submodelZRotation)}
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <span className='red-question-mark fw-bold'>?</span>
                                )
                            }
                        </div>
                        <div className='mb-1'>
                            <span
                                className='text-decoration-underline cursor-pointer'
                                onClick={
                                    () => {
                                        if (onSubmodelNameClick) onSubmodelNameClick();

                                        if (submodelNameHandlerRef.current) submodelNameHandlerRef.current.focusOnSubmodelNameInput();
                                    }
                                }
                            >
                                Subelem név
                            </span>
                            <br />
                            <LayerItemSubmodelNameHandler
                                submodelName={layerItem.submodelName}
                                changeable={layerItem.changeableSubmodelName}
                                onSave={(name) => { if (onSubmodelNameSaveClick) onSubmodelNameSaveClick(name); }}
                                onCancel={() => { if (onSubmodelNameCancelClick) onSubmodelNameCancelClick(); }}
                                ref={submodelNameHandlerRef as React.LegacyRef<LayerItemSubmodelNameHandlerRef>}
                            />
                        </div>
                    </AccordionBody>
                </AccordionItem>
            </Accordion>
        </>
    );
};